import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $q, $filter, claimViewModel, PolicyService, TranslateService, LocaleService, AddressUtil, propertiesPageSize) {
    $scope.pageSize = propertiesPageSize;

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.reset = false;
        $scope.loading = true;
        $scope.errorMsg = null;
        $scope.filterApplicable = null;
        $scope.query = null;

        $scope.allRiskUnits = null;
        $scope.riskUnits = null;
        $scope.filteredRiskUnits = null;
        $scope.selectedRiskUnits = null;
        $scope.sharedPageNum = null;

        $scope.inUpdateState = false;

        if (!$scope.claimVm.policy.lobs.commercialProperty) {
            $scope.claimVm.policy.lobs.value = { commercialProperty: { propertyRiskUnits: [] } };
        }

        $scope.policyRiskUnits = $scope.claimVm.policy.lobs.commercialProperty.propertyRiskUnits.value;

        ctrl.translateMessages();
        ctrl.initRiskUnits();
    };

    ctrl.translateMessages = function () {
        $scope.translation = {
            label: '',
            error: ''
        };

        TranslateService.translate({
            object: $scope.translation,
            displayKey: 'fnol.cp.views.properties.Buildings',
            propName: 'label',
            scope: $scope
        });

        TranslateService.translate({
            object: $scope.translation,
            displayKey: 'fnol.cp.views.properties.No results found. Please try widening your search criteria.',
            propName: 'error',
            scope: $scope
        });
    };

    ctrl.initRiskUnits = function () {
        $scope.loading = true;
        $scope.errorMsg = null;
        $scope.loader = PolicyService.getPolicySummaryRiskUnits($scope.claimVm.policy.policyNumber.value, $scope.claimVm.lossDate.value).then(function (riskUnits) {
            $scope.loading = false;
            $scope.allRiskUnits = riskUnits.lobs.commercialProperty.propertyRiskUnits;
            $scope.riskUnits = riskUnits.lobs.commercialProperty.propertyRiskUnits;
            $scope.allRiskUnits.forEach(function (riskUnit) {
                riskUnit.address = AddressUtil.format(riskUnit);
                riskUnit.selected = $scope.policyRiskUnits.findIndex(function (unit) {
                    return unit.policySystemId === riskUnit.policySystemId;
                }) > -1;
            });
            ctrl.updateSelectionSummary();
        }, function (error) {
            $scope.errorMsg = $scope.translation.error + error;
        });
    };

    ctrl.riskUnitsChanged = function () {
        $scope.riskUnits.forEach(function (unit) {
            var index = $scope.policyRiskUnits.findIndex(function (policyUnit) {
                return policyUnit.policySystemId === unit.policySystemId;
            });
            if (unit.selected && index < 0) {
                $scope.policyRiskUnits.push(unit);
            } else if (!unit.selected && index >= 0) {
                $scope.policyRiskUnits.splice(index, 1);
            }
        });
    };

    ctrl.updateSelectionSummary = function () {
        $scope.selectedRiskUnits = $scope.allRiskUnits.filter(function (ru) {
            return $scope.policyRiskUnits.findIndex(function (policyUnit) {
                return policyUnit.policySystemId === ru.policySystemId;
            }) !== -1;
        });
    };

    ctrl.updateRiskUnitsList = function (riskUnits) {
        $scope.riskUnits = riskUnits;
        $scope.reset = !$scope.reset;
        $scope.inUpdateState = true;
    };

    ctrl.onPaginationNavigation = function (riskUnits, pageNum) {
        if ($scope.inUpdateState || pageNum !== $scope.sharedPageNum) {
            $scope.filteredRiskUnits = riskUnits.items;
            $scope.sharedPageNum = pageNum;
            $scope.inUpdateState = false;
        }
    };

    ctrl.toggleRiskUnitSelection = function (unit) {
        unit.selected = !unit.selected;
        ctrl.riskUnitsChanged();
        ctrl.updateSelectionSummary();
    };

    ctrl.updateFilterState = function (queriedData, filterApplicable, query) {
        ctrl.updateRiskUnitsList(queriedData);
        $scope.filterApplicable = filterApplicable;
        $scope.query = query;
    };

    ctrl.formatCellContent = function (content) {
        return $scope.filterApplicable ? $filter('highlightPhrase')(content, $scope.query, 'bold') : content;
    };

    ctrl.getSortingStyle = function (attribute, sortingProperty, numeric, descending) {
        var icon = null;
        var type = 'gw_cp__sort-indicator-icon';

        if (!sortingProperty || sortingProperty !== attribute) {
            // no sorting applied or sorting property is different than considered attribute/column
            // need to provide 'neutral' icon
            icon = 'fa-exchange fa-rotate-90';
            type += '_inactive';
        } else {
            // sorting applies to the considered attribute
            // need to provide proper icon depending on the direction
            icon = 'fa-sort-' + (numeric ? 'amount' : 'alpha') + '-' + (descending ? 'desc' : 'asc');
            type += '_active';
        }
        return 'fa ' + icon + ' ' + type;
    };

    ctrl.next = function (nextFn) {
        nextFn($scope.claimVm);
    };

    ctrl.sortProperties = function (attribute, descending) {
        var direction = descending ? -1 : 1;
        var locales = LocaleService.getCurrentLocale().replace('_', '-') + '-u-kn-true';

        var sortedRiskUnits = $scope.allRiskUnits.slice().sort(function (x, y) {
            var xValue = x && x[attribute] ? x[attribute] : '';
            var yValue = y && y[attribute] ? y[attribute] : '';
            var comparisonResult = xValue.localeCompare(yValue, locales);
            return direction * comparisonResult;
        });
        $scope.allRiskUnits = sortedRiskUnits;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$q', '$filter', 'claimViewModel', 'fnol.PolicyService', 'TranslateService', 'LocaleService', 'AddressUtil', 'propertiesPageSize'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/cp/controllers/CPRiskUnitsCtrl.js
// module id = 1535
// module chunks = 0